export default {
  title: 'Tilauksen tiedot',
  order_again: 'Tilaa uudelleen',
};
